import { HostListener, Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

import { Keepalive } from '@ng-idle/keepalive';
import { OAuthService } from 'angular-oauth2-oidc';
import Swal from 'sweetalert2';
import { AuthenticationService } from './digigov/services/authentication.service';

export const broadCastChannelSessionTimeout = new BroadcastChannel("SESSION_TIMEOUT");

@Injectable({ providedIn: 'root' })
export class IdleService { 

  swalAlert =Swal.mixin({
    
  });



  constructor(
    private oauthService: OAuthService,
    private idle: Idle,
    private keepalive: Keepalive,
    private authenticationService :AuthenticationService
  ) {
    

    window.addEventListener('storage', (event) => {
      if (event.key === 'idleState' && event.newValue === 'Started') {
        this.idle.stop();
        this.idle.watch();
      }

      if (event.key === 'idleState' && event.newValue === 'Stopped') {
        this.idle.stop();
      }
    });
  }

  setupSessionIdle(idleTime:number,timeoutTime:number) {
    this.idle.setIdle(idleTime*60);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(timeoutTime*60);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      if (this.oauthService.hasValidAccessToken()) {
        console.log('No longer idle.');
        this.swalAlert.close();
      }
    });
    this.idle.onTimeout.subscribe(() => {
      if (this.oauthService.hasValidAccessToken()) {
        console.log('Timed out!');
       this.authenticationService.logout();
      }
    });
    this.idle.onIdleStart.subscribe(() => {
      if (this.oauthService.hasValidAccessToken()) {
        console.log("You've gone idle!");
        this.idleMessage();
      }
    });

    /* idle.onTimeoutWarning.subscribe(
      (countdown) =>
        (this.idleState = 'You will time out in ' + countdown + ' seconds!')
    ); */

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    // keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
  }

  reset() {
    if (this.oauthService.hasValidAccessToken()) {
      this.startWatching();
    }
  }

  startWatching() {
    this.idle.stop();
    this.idle.watch();
    localStorage.setItem('idleState', 'Started');
  }

  stopWatching() {
    this.idle.stop();
    localStorage.setItem('idleState', 'Stopped');
  } 

  idleMessage(){
    this.swalAlert.fire({
      icon: "warning",
      iconColor: "#1864ab",
      title: "You've gone Idle",
      text: "It was detected that you have gone idle. You will be logged out in 1 minute if you stay idle.",
      //confirmButtonText: "OK",
      //confirmButtonColor: "#1864ab",
      showConfirmButton: false,
      allowOutsideClick: false,
    });
  }
}
